import { z } from 'zod';
// KIR-3035: endpoint (machine) identity + details surfaced across Inventory,
// Alerts, and Shadow-AI. An endpoint is a machine the Kirin agent runs on,
// keyed by the agent's persisted machine_id.
/** Full details for one endpoint, as shown in the inventory endpoints dialog. */
export const endpointDetailsSchema = z.object({
    /** The agent's persisted machine_id — the endpoint ID throughout the feature. */
    machineId: z.string(),
    /** Hostname. */
    name: z.string().nullable(),
    osString: z.string().nullable(),
    ipAddresses: z.array(z.string()),
    macAddresses: z.array(z.string()),
    /** Agent version as of the last endpoint report (the agent's periodic
     * endpoint reporter, ~hourly — not the keepalive/handshake path). */
    agentVersion: z.string().nullable(),
    lastSeen: z.string().datetime().nullable(),
    firstSeen: z.string().datetime().nullable(),
});
/** A user's endpoints, returned by the inventory endpoints endpoint. */
export const endpointListSchema = z.object({
    endpoints: z.array(endpointDetailsSchema),
});
/** Payload the agent's periodic endpoint reporter POSTs to upsert the registry. */
export const reportEndpointSchema = z.object({
    machineId: z.string().min(1),
    name: z.string().nullable().optional(),
    osString: z.string().nullable().optional(),
    // `.nullable()` as well as `.optional()`: a client that serializes an empty
    // address list as JSON `null` (e.g. a Go nil slice without omitempty) must not
    // 400 the whole report — null is treated as "no addresses reported" (KIR-3035).
    ipAddresses: z.array(z.string()).nullable().optional(),
    macAddresses: z.array(z.string()).nullable().optional(),
    agentVersion: z.string().nullable().optional(),
});
//# sourceMappingURL=endpoints.js.map